import {
    GLOBAL_DESTINATIONS,
    GLOBAL_PROVIDER_SETGINGS,
} from "./actionTypes";

export const getDestinations = (data) => ({
    type: GLOBAL_DESTINATIONS,
    data
})

export const globalProviderSettings = (data) => ({
    type: GLOBAL_PROVIDER_SETGINGS,
    data
})


// WEBPACK FOOTER //
// ./src/actions/globalActions.js